import React from 'react';
import { Dropdown, Avatar } from 'antd';
import { UserOutlined, DownOutlined } from '@ant-design/icons';
import { useAppAuth } from '@contexts/AuthContext';
import ButtonComp from '@components/UI/Button/Index';
import { perfilUsuarioOptions } from '@enums/Usuario/Index';

const LogoutDropdown = () => {
  const { nome, email, role, nomeUnidadeGerencia, logout } = useAppAuth();

  const perfil = perfilUsuarioOptions.find(option => option.value === role)

  /* items no formato exigido pelo Antd v5 */
  const items = [
    {
      key: 'header',
      disabled: true,
      label: (
        <div style={{ cursor: 'default', display: 'flex', flexDirection: 'column', minWidth: 200 }}>
          <span className="text-muted" style={{ wordBreak: 'break-word' }}>
            <strong>E-mail:</strong> {email}
          </span>
          <span className="text-muted" style={{ wordBreak: 'break-word' }}>
            <strong>Perfil:</strong> {perfil.label ?? '—'}
          </span>
          {nomeUnidadeGerencia && (
            <span className="text-muted" style={{ wordBreak: 'break-word' }}>
              <strong>Unidade/Gerência:</strong> {nomeUnidadeGerencia ?? '—'}
            </span>
          )}
        </div>
      ),
    },
    { type: 'divider' },
    {
      key: 'logout',
      label: (
        <div className='d-flex justify-content-center align-items-center'>
          <ButtonComp
            title="ENCERRAR SESSÃO"
            buttonColor={"#2b97be"}
            classnameIcon="fa-solid fa-arrow-right-from-bracket"
            hoverMessage="Clique para sair do sistema"
            onClick={logout}
            type="button"
          />
        </div>
      ),
    }
  ];

  /* clique no item */
  const onClick = ({ key }) => {
    if (key === 'logout') {
      logout();
    }
  };

  return (
    <Dropdown menu={{ items, onClick }} trigger={['click']}>
      <span
        className="d-inline-flex align-items-center user"
        style={{ cursor: 'pointer' }}
      >
        <Avatar size={28} icon={<UserOutlined />} className="me-3" />
        {nome}
        <DownOutlined className="ms-2" />
      </span>
    </Dropdown>
  );
};

export default React.memo(LogoutDropdown);
